import React from "react";
import { Helmet } from 'react-helmet';
import { motion } from "framer-motion";

import "./hero-section.css";
const HeroSection = () => {
  return (
    <>
    {/* SEO Metadata */}
    <Helmet>
        <title>Nora Cake</title>
        <meta name="description" content="Vancouver, Langley, Surrey, Burnaby, home made cake, wedding cake, birthday cake" />
        <meta name="keywords" content="Vancouver, Langley, Surrey, Burnaby, customise cake, home made cake, wedding cake, birthday cake." />
        <meta name="author" content="Nora Cake" />
        <meta property="og:title" content="Home made cakes, baked with love & flavor!" />
        <meta property="og:description" content="We make homemade cakes and bakeries with organic ingredients as much as possible." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://noracake.ca" />
        <meta property="og:image" content="https://noracake.ca/assets/wedding-cake-2.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Home made cakes, baked with love & flavor!" />
        <meta name="twitter:description" content="We make homemade cakes and bakeries with organic ingredients as much as possible." />
        <meta name="twitter:image" content="https://noracake.ca/assets/wedding-cake-2.jpg" />
      </Helmet>
      <div className="ng-tns-c3-1 ng-star-inserted">
        <div
          className="container d-flex align-items-center justify-content-center ng-tns-c3-1"
          style={{ marginTop: "40px" }}
        >
          <div className="row d-flex flex-column-reverse gap-5 gap-xl-0 flex-xl-row ng-tns-c3-1">
            <div className="col-xl-6 gap-3 d-flex flex-column justify-content-center align-items-xl-start ng-tns-c3-1">
              <motion.h1
                whileInView={{ y: [-100, 0], opacity: [0, 1] }}
                transition={{ duration: 0.8 }}
                className="fw-bold"
              >
                  Homemade cakes, baked with love & flavor!
              </motion.h1>

              <motion.p className="fs-5"  whileInView={{ y: [100, 0], opacity: [0, 1] }}
                transition={{ duration: 0.8 }}>
                {" "}
                We make homemade cakes and bakeries with organic ingredients as much as possible.{" "}
              </motion.p>

              <motion.div
                whileInView={{ y: [100, 0], opacity: [0, 1] }}
                transition={{ duration: 0.8, delay: 0.2 }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: '10px 16px',
                  backgroundColor: '#f0f9ff',
                  border: '1px solid #bae6fd',
                  borderRadius: '8px',
                  borderLeft: '4px solid #0ea5e9',
                }}
              >
                <div style={{
                  width: 24,
                  height: 24,
                  backgroundColor: '#0ea5e9',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: 12,
                  fontWeight: 'bold'
                }}>
                  ✓
                </div>
                <div style={{ fontSize: 18, color: '#0c4a6e', lineHeight: 1.4 }}>
                  Food Safety Certified - All our products meet health and safety standards
                </div>
              </motion.div>
              {/*
              <motion.button className="herosection-btn"
                whileInView={{ y: [100, 0], opacity: [0, 1] }}
                transition={{ duration: 0.8 }}
                > Join our discord
              </motion.button>
              */}
              {/**/}
            </div>
            <motion.div className="col-xl-6 flex justify-content-center ng-tns-c3-1" whileInView={{ x: [100, 0], opacity: [0, 1] }}
                transition={{ duration: 0.8 }}>
              <img src="/assets/wedding-cake-2.jpg" alt="" className="herosection-img" />
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
